"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FavoriteTransport = void 0;
var FavoriteTransport;
(function (FavoriteTransport) {
    FavoriteTransport["METRO_BUS"] = "METRO_BUS";
    FavoriteTransport["CAR"] = "CAR";
    FavoriteTransport["SCOOTER"] = "SCOOTER";
    FavoriteTransport["BIKE"] = "BIKE";
})(FavoriteTransport = exports.FavoriteTransport || (exports.FavoriteTransport = {}));
//# sourceMappingURL=FavoriteTransport.js.map